import { Navigate } from 'react-router-dom'
import { usePermissions } from '../hooks/usePermissions'
import { PERMISSIONS } from '../lib/permissions'

// Landing decision for "/" and the catch-all route. Everyone historically landed on
// /dashboard, but that page fires stats queries a DeliveryDriver role has no
// permission for — a driver would open on a screen of error toasts after every
// login. Send dashboard-less drivers to their own screen; everyone else keeps the
// old behavior.
const HomeRedirect = () => {
  const { hasPermission, canSeeNavigation, permissionsLoading, apiPermissions, role } = usePermissions()

  // Hold off ONLY when we know nothing at all. Right after login the Apollo cache
  // was just reset, so the live permission query is always in flight here — but the
  // login snapshot (role.permissions) is fresh from that same login response and
  // the checks below fall back to it, so blanking the screen until the query lands
  // would gain nothing. The stale-snapshot case PermissionGuard holds off for (a
  // permission seeded after login) costs at most one landing on the old default,
  // corrected once the live query resolves.
  const snapshotReady = Boolean(role?.permissions?.length)
  if (permissionsLoading && apiPermissions.length === 0 && !snapshotReady) {
    return null
  }

  if (!canSeeNavigation('Dashboard') && hasPermission(PERMISSIONS.DELIVERY_DRIVE)) {
    return <Navigate to="/driver" replace />
  }

  return <Navigate to="/dashboard" replace />
}

export default HomeRedirect
